const CSV_HEADERS = [
  "Created",
  "Shop Number",
  "Shop Name",
  "Supplier",
  "Reference",
  "Client",
  "Item Cost",
  "Pick and Pack",
  "Shipping",
  "Total",
  "Currency",
] as const;

function csvCell(value: unknown): string {
  const text = null === value || undefined === value ? "" : String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

/**
 * Builds CSV from rows already shaped by mapRowDataByConfig (fields nested under
 * each column accessorKey). Cost breakdown lives on the Actions column.
 */
export function buildPodBillsCsv(
  selected: Record<string, unknown>[],
): string {
  const lines = [
    CSV_HEADERS.join(","),
    ...selected.map((row) => {
      const dateInvoiced = row.date_invoiced as
        | Record<string, unknown>
        | undefined;
      const shop = row.shop_number as Record<string, unknown> | undefined;
      const supplier = row.division_name as Record<string, unknown> | undefined;
      const reference = row.customer_po as Record<string, unknown> | undefined;
      const client = row.client as Record<string, unknown> | undefined;
      const actions = row.actions as Record<string, unknown> | undefined;
      const total = row.total as Record<string, unknown> | undefined;

      return [
        csvCell(dateInvoiced?.date_invoiced),
        csvCell(shop?.shop_number),
        csvCell(shop?.shop_name),
        csvCell(supplier?.division_name),
        csvCell(reference?.customer_po),
        csvCell(client?.client_name),
        csvCell(actions?.item_cost),
        csvCell(actions?.pick_and_pack),
        csvCell(actions?.shipping),
        csvCell(total?.total),
        csvCell(total?.currency_id),
      ].join(",");
    }),
  ];

  return lines.join("\n");
}
